import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import data from '../data.js';

export default function Blog(props) {
    const [shift, setShift] = useState(0);
    useEffect(() => {
        window.scrollTo(0, 0);
        const getHeight = document.getElementById('divShift').offsetHeight;
        const newShift = '-' + getHeight + 'px';
        setShift(newShift);
        const resizeListener = () => {
            const getHeight = document.getElementById('divShift').offsetHeight;
            const newShift = '-' + getHeight + 'px';
            setShift(newShift);
        };
        window.addEventListener('resize', resizeListener);
        return () => {
            window.removeEventListener('resize', resizeListener);
        }
    }, []);
    let divShift = {
        marginTop: shift
    };
    return (
        <>
        <h1 id='divShift' style={divShift}>Blog</h1>
        <div className="container blog-snippet">
            {data.map((post) => {
                const to = '/blog/' + post.id;
                return (
                <div className='row justify-content-center' style={{marginBottom: '3rem'}} key={post.id}>
                    <div className='col-lg-8 col-md-10'>
                        <h3>{post.ShortTitle}</h3>
                        <p><span className='pr-3'>{post.AuthorFirstName} {post.AuthorLastName}</span> | <span className='pl-3'>{post.Date}</span></p>
                        <p className='pb-3'>{post.Snippet}</p>
                        <Link className='button-blue-white' to={to}>Read more</Link>
                    </div>
                </div>
                )
            })}
        </div>
        </>
    )
}